import HomeImage from '../../static/images/home_image.jpg';

function Hero(){
  return (
    <section className="relative w-full overflow-hidden bg-white">
      {/* Content wrapper */}
      <div className="mx-auto grid min-h-[70vh]  grid-cols-1 lg:grid-cols-2">
        {/* Left: Text block */}
        <div className="flex items-end lg:items-center px-6 sm:px-10 lg:px-14 xl:px-20 py-10 lg:py-20">
          <div className="w-full">
            <h1 className="font-semibold tracking-tight text-gray-900 text-4xl sm:text-5xl md:text-6xl xl:text-7xl">
              Get a Free HIV Self-Test Kit Today
            </h1>
            <p className="mt-8 text-sm italic text-gray-500">
              Powered by Heartland Alliance LTD/GTE
            </p>
          </div>
        </div>

        <div className="relative min-h-[320px] lg:min-h-[70vh] col-span-1">
          <img
            src={HomeImage}
            alt="Happy Couple"
            className="absolute inset-0 h-full w-full object-cover"
          />
        </div>
      </div>
    </section>
  );
}
export default Hero;

